import { QueryClient } from '@tanstack/react-query';
import { isNil } from 'lodash-es';
import serviceNoParamsToTQInterface from 'services/tq-adapter/serviceNoParamsToTQInterface';
import serviceWithParamsToTQInterface from 'services/tq-adapter/serviceWithParamsToTQInterface';
import { OneServiceNoParams, OneServiceWithParams } from 'types/services/services';

/**
 * Convert a service with or without params to tanstack query inteface
 * @param queryClient the tanstack query client
 * @param service the service to use
 * @param params the params for the service
 * @returns the interface for tanstack query
 */
function serviceToTQInterface<Data, Params extends object>(
  queryClient: QueryClient,
  service: Params extends object ? OneServiceWithParams<Data, Params> : OneServiceNoParams<Data>,
  params?: Params,
) {
  return isNil(params)
    ? serviceNoParamsToTQInterface(service as OneServiceNoParams<Data>, queryClient)
    : serviceWithParamsToTQInterface(service as OneServiceWithParams<Data, Params>, params, queryClient);
}

export default serviceToTQInterface;
